import { createSelector } from '@ngrx/store';
import { catalogsFeature, catalogsAdapter } from './catalog.reducer';

export const {
  selectCatalogsState,
  selectTotal: selectCatalogsTotal,
  selectPage: selectCatalogsPage,
  selectLimit: selectCatalogsLimit,
  selectLoading: selectCatalogsLoading,
  selectError: selectCatalogsError,
  selectExtraFieldsTemplate: selectProspectExtraFieldsTemplate,
  selectExtraFieldsTemplateLoaded: selectProspectExtraFieldsTemplateLoaded,
  selectExtraFieldsTemplateLoading: selectProspectExtraFieldsTemplateLoading,
} = catalogsFeature;

const entitySelectors = catalogsAdapter.getSelectors(selectCatalogsState);
export const selectAllCatalogs = entitySelectors.selectAll;
export const selectCatalogEntities = entitySelectors.selectEntities;

/** Only fields the tenant has named (decision D6: configured means `label !== ''`). */
export const selectConfiguredProspectExtraFields = createSelector(
  selectProspectExtraFieldsTemplate,
  (fields) => fields.filter((f) => f.label !== ''),
);
